<template>
    <section class="esesja-modal">
        <section class="esesja-modal__wraper">
            <section class="esesja-modal__wraper__header">
                <h3 class="esesja-modal__wraper__header__title">{{att.id == 0 ? $t('com.file.add-link-modal.add-link') : $t('com.file.add-link-modal.edit-link')}}</h3>
                <button class="esesja-modal__wraper__header__exit-btn"
                        @click=" (e)=>{e.preventDefault(); this.$emit('closeAddLink');}">
                    <img src="../../../../../assets/icons/components/exit-btn.svg" />
                </button>
            </section>
            <perfect-scrollbar class="esesja-modal__wraper__body">
                <label class="esesja-modal__wraper__body__label">{{$t('com.file.add-link-modal.file-name')}}</label>
                <section class="esesja-modal__row">
                    <input type="text"
                           :placeholder="$t('com.file.add-link-modal.file-name-placeholder')"
                           class="esesja-modal__wraper__body__input"
                           v-model="name" />
                </section>

                <label class="esesja-modal__wraper__body__label">{{$t('com.file.add-link-modal.url-address')}}</label>
                <section class="esesja-modal__row">

                    <input type="text"
                           placeholder="http://"
                           class="esesja-modal__wraper__body__input"
                           v-model="url" />
                </section>

                <section>
                    <div class="form-bootstrap-check form-bootstrap-switch">
                        <input class="form-bootstrap-check-input" type="checkbox" role="switch" id="public-attachement" v-model="isPublic" @change="changeVisibleFlags()" />
                        <label class="form-bootstrap-check-label" for="public-attachement">{{$t('com.file.add-link-modal.public')}}</label>
                        <section name="externalTrigger2"
                                 class="tip-btn">
                            <img src="../../../../../assets/icons/components/tooltip.svg"
                                 class="tooltip" />
                            <Hint :title="$t('com.file.add-group.public-file')"
                                  :text="$t('com.file.add-link-modal.public-file-info-hint')" />
                        </section>
                    </div>
                </section>

                <section>
                    <div class="form-bootstrap-check form-bootstrap-switch">
                        <input class="form-bootstrap-check-input" type="checkbox" role="switch" id="visible-for-users" v-model="isVisibleForUsers" @change="changePublicFlags()" />
                        <label class="form-bootstrap-check-label" for="visible-for-users">{{$t('com.file.add-link-modal.show-for-users')}}</label>
                        <section name="externalTrigger2"
                                 class="tip-btn">
                            <img src="../../../../../assets/icons/components/tooltip.svg"
                                 class="tooltip" />
                            <Hint style="left: calc(100% - 310px)" :title="$t('com.file.add-link-modal.show-for-users')"
                                  :text="$t('com.file.add-link-modal.show-for-users-info-hint')" />
                        </section>
                    </div>
                </section>

                <section class="esesja-modal__wraper__body__bottom" style="margin-top: 20px;">
                    <button class="esesja-modal__wraper__body__bottom-button"
                            @click="this.$emit('closeAddLink')">
                        {{$t('com.global.cancel')}}
                    </button>
                    <button class="
                        esesja-modal__wraper__body__bottom-button
                        esesja-modal__wraper__body__bottom-button--red
                    "
                            @click="handleSaveClick" :disabled="name.length == 0 || url.length < 8">
                        {{$t('com.global.save')}}
                    </button>
                </section>
            </perfect-scrollbar>

        </section>
        <LoaderInside v-if="isLoading" />
    </section>
</template>

<script>
import LoaderInside from "../../../../BasicControls/LoaderInside.vue";
import Hint from "../../../../BasicControls/Hint.vue";
import AttachmentService from "../../../../../services/attachments.service";
import { notifySessionContentChanged } from "@/helpers/sessionContentNotify.helper";

export default {
    name: "AddLink",
    data() {
        return {
            name: this.att.name,
            url: this.att.url,
            isLoading: false,
            isPublic: this.att.public == 1 ? true : false,
            isVisibleForUsers: this.att.visible_for_users == 1 ? true : false
        };
    },
    props: {
        pointID: Number,
        att: Object
    },
    components: {
        LoaderInside,
        Hint
    },
    methods: {
        changeVisibleFlags() {
            if (this.isPublic) {
                this.isVisibleForUsers = true;
            }
        },
        changePublicFlags() {
            if (!this.isVisibleForUsers) {
                this.isPublic = false;
            }
        },
        handleSaveClick() {
            this.isLoading = true;
            const data = {
                id: this.att.id,
                name: this.name,
                url: this.url,
                isPublic: this.isPublic,
                isVisibleForUsers: this.isVisibleForUsers
            };

            AttachmentService.addLink(this.pointID, data).then(() => {
                this.name = "";
                this.url = "";
                this.isPublic = false;
                this.isVisibleForUsers = false;
                notifySessionContentChanged(this.$route.params.sessionid);
                this.$emit("reload");
                this.$emit("closeAddLink");
                this.isLoading = false;
            });
        },
    },
};
</script>

<style lang="scss" scoped>

    @use "../../../../../assets/scss/esesja-modal.scss";

    .switch-section {
        display: flex;
        margin-bottom: 12px;
    }

    .tooltip {
        position: relative;
        left: 5px;
        top: -3px;
    }

    .tip-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        border: 0px;
        background-color: transparent;
        width: 20px;
        height: 20px;
        position: relative;
        cursor: pointer;

        &:hover .hint {
            opacity: 1;
            display: block;
        }
    }
</style>

